module.exports = __webpack_public_path__ + "static/img/about-us.c77330c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us.jpg
// module id = Pw5Y
// module chunks = 0